import React from "react";
import Modal from "../AbstractModal/AbstractModal";
import './CustomerModal.scss';
import CustomerForm from "~/components/forms/CustomerForm/CustomerForm";

export default ({ customerId }: { customerId: string }) => (
  <Modal title={`${customerId ? 'Edit' : 'Add'} Customer`} className='CustomerModal'>
    <div><CustomerForm customerId={customerId} /></div>
  </Modal>
);